import { BadgeCheck, MapPin, MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/config/site";

// Enquiries go through the directory's WhatsApp — it assists with referrals and
// does not operate or represent every facility.
const ProviderCard = ({ provider }) => (
  <article
    data-testid={`provider-card-${provider.id}`}
    className="flex h-full flex-col rounded-2xl border border-slate-100 bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
  >
    <div className="flex items-start justify-between gap-3">
      <h3 className="font-display text-lg font-semibold text-brand-charcoal">{provider.name}</h3>
      {provider.lastVerified && (
        <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-brand-sageLight px-2.5 py-1 text-[11px] font-semibold text-brand-sage">
          <BadgeCheck className="h-3.5 w-3.5" /> Verified {provider.lastVerified}
        </span>
      )}
    </div>
    <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500">
      <MapPin className="h-4 w-4 text-brand-coral" /> {provider.address}, {provider.area}
    </p>
    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{provider.description}</p>
    {provider.roomInfo && <p className="mt-2 text-xs text-slate-500">Rooms: {provider.roomInfo}</p>}
    {provider.priceInfo && <p className="mt-1 text-xs text-slate-500">Fees: {provider.priceInfo}</p>}
    <div className="mt-auto pt-4">
      <div className="flex gap-3">
        <a
          href={waLink(WA_MESSAGES.referral(provider.name))}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`provider-enquire-${provider.id}`}
          className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-teal px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-gold transition-colors duration-300"
        >
          <MessageCircle className="h-4 w-4" /> Enquire via Directory
        </a>
      </div>
      <p className="mt-3 text-[11px] leading-relaxed text-slate-400">
        Nursing Home in Penang is an independent directory. We assist with referrals and do not operate or represent
        this facility. Please confirm all services, fees and availability directly with the provider.
      </p>
    </div>
  </article>
);

export default ProviderCard;
